import { useState } from "react";
import { toast } from "sonner";
import { Loader2, Sparkles, Wand2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import api, { errMsg } from "@/lib/api";

export const TONES = [
  { v: "santai", l: "Santai" },
  { v: "profesional", l: "Profesional" },
  { v: "jualan", l: "Jualan" },
  { v: "lucu", l: "Kelakar" },
];

export function ToneSelect({ value, onChange, testId }) {
  return (
    <Select value={value} onValueChange={onChange}>
      <SelectTrigger className="h-9 w-36 bg-background" data-testid={testId}><SelectValue /></SelectTrigger>
      <SelectContent>{TONES.map((t) => <SelectItem key={t.v} value={t.v}>{t.l}</SelectItem>)}</SelectContent>
    </Select>
  );
}

export default function AiWriter({ onWrite }) {
  const [open, setOpen] = useState(false);
  const [brief, setBrief] = useState("");
  const [tone, setTone] = useState("santai");
  const [busy, setBusy] = useState(false);

  const run = async () => {
    setBusy(true);
    try {
      const { data } = await api.post("/ai/write", { brief, tone });
      onWrite(data.text);
      toast.success("AI siap menulis post");
      setOpen(false);
    } catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };

  if (!open)
    return (
      <Button type="button" variant="outline" size="sm" onClick={() => setOpen(true)} className="border-violet-500/40 text-violet-300 hover:bg-violet-500/10 hover:text-violet-200" data-testid="composer-ai-write-open-btn">
        <Wand2 className="mr-1.5 h-3.5 w-3.5" /> Tulis dengan AI
      </Button>
    );
  return (
    <div className="ai-glow fade-up w-full rounded-xl bg-violet-500/5 p-4" data-testid="composer-ai-write-box">
      <p className="flex items-center gap-1.5 text-sm font-semibold text-violet-300"><Sparkles className="h-4 w-4" /> Beritahu AI apa yang anda nak promosi</p>
      <Textarea value={brief} onChange={(e) => setBrief(e.target.value)} rows={3} className="mt-3 bg-background" placeholder="cth: Kek lapis Sarawak, RM35, promosi hujung minggu, hantar sekitar KL, WhatsApp 012-3456789" data-testid="composer-ai-brief-input" />
      <div className="mt-3 flex flex-wrap items-center gap-2">
        <ToneSelect value={tone} onChange={setTone} testId="composer-ai-write-tone" />
        <Button type="button" size="sm" onClick={run} disabled={busy || brief.trim().length < 3} className="bg-violet-600 hover:bg-violet-500" data-testid="composer-ai-write-btn">
          {busy ? <Loader2 className="mr-1.5 h-3.5 w-3.5 animate-spin" /> : <Wand2 className="mr-1.5 h-3.5 w-3.5" />} Jana post
        </Button>
        <Button type="button" size="sm" variant="ghost" onClick={() => setOpen(false)} data-testid="composer-ai-write-cancel-btn">Tutup</Button>
      </div>
    </div>
  );
}
